import api from './axiosInstance';

export const getAccountsApi            = (params) => api.get('/accounts', { params });
export const getAccountByIdApi         = (id, params) => api.get(`/accounts/${id}`, { params });
export const getBuyerDetailApi         = (account_id) => api.post('/buyer/detail', { account_id });
export const createAccountApi          = (data) => api.post('/accounts', data);
export const updateAccountApi          = (id, data) => api.put(`/accounts/${id}`, data);
export const deleteAccountApi          = (id) => api.delete(`/accounts/${id}`);

export const addTransactionApi         = (accountId, data) => api.post(`/accounts/${accountId}/transactions`, data);
export const updateTransactionApi      = (id, data) => api.put(`/transactions/${id}`, data);
export const deleteTransactionApi      = (id) => api.delete(`/transactions/${id}`);
export const updateTransactionStatusApi = (data) => api.patch('/transactions/status', data);

export const getShopkeeperDetailApi     = (data) => api.post('/user/shopkeeper/detail', data);
export const addLabourTransactionApi    = (data) => api.post('/add-labour-transaction', data);
export const updateLabourTransactionApi = (data) => api.patch('/update-labour-transaction', data);
export const deleteLabourTransactionApi = (data) => api.delete('/delete-labour-transaction', { data });
export const getSalaryApi              = () => api.get('/salary');
export const addSalaryApi              = (data) => api.post('/salary', data);
